<div class="group relative flex cursor-pointer">
  <button hlmBtn [variant]="btnVariant" class="h-12 rounded-xl px-5 text-base">
    {{ title }}
  </button>
  <button hlmBtn [variant]="btnVariant" class="-ml-[1px] h-12 w-12 rounded-xl">
    <lucide-icon [name]="icon" size="20"></lucide-icon>
  </button>
</div>
